<template>
  <CModal
    title="Add sales tax"
    :show="show"
    @update:show="$emit('close')"
  >
    <CInput
      ref="nameInput"
      v-model="localSalesTax.name"
      label="Tax name *"
      placeholder="e.g. SST 6%"
      description="A short name you'll recognise on invoices, such as 'SST 6%'"
      :is-valid="nameValid"
      invalid-feedback="Enter a name for this tax, such as 'SST 6%'"
    />
    <CInput
      ref="rateInput"
      v-model="localSalesTax.rateInPercentage"
      label="Tax rate (%) *"
      type="number"
      inputmode="decimal"
      min="0"
      max="100"
      step="0.01"
      placeholder="0.00"
      description="For 6%, enter 6"
      :is-valid="rateValid"
      invalid-feedback="Enter a rate from 0 to 100, such as 6"
    />
    <CTextarea
      v-model="localSalesTax.description"
      label="Description (optional)"
      rows="3"
    />
    <template #footer>
      <div class="d-flex justify-content-between w-100">
        <CButton color="light" @click="$emit('close')">Cancel</CButton>
        <CButton color="primary" @click="saveSalesTax">Add tax</CButton>
      </div>
    </template>
  </CModal>
</template>

<script>
const emptyTax = () => ({ name: "", rateInPercentage: 0, description: "", isActive: true });

export default {
  name: "SalesTaxFormModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    salesTax: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localSalesTax: { ...emptyTax(), ...this.salesTax },
      submitted: false,
    };
  },
  watch: {
    salesTax: {
      handler(newSalesTax) {
        this.localSalesTax = { ...emptyTax(), ...newSalesTax };
      },
      deep: true,
    },
    show(newValue) {
      if (newValue) {
        this.localSalesTax = { ...emptyTax(), ...this.salesTax };
        this.submitted = false;
      }
    },
  },
  computed: {
    nameOk() {
      const n = this.localSalesTax.name;
      return !!(n && String(n).trim().length > 0);
    },
    rateOk() {
      const r = this.localSalesTax.rateInPercentage;
      if (r === null || r === undefined || r === "") return false;
      const n = parseFloat(r);
      return !isNaN(n) && n >= 0 && n <= 100;
    },
    nameValid() {
      return this.submitted ? this.nameOk : null;
    },
    rateValid() {
      return this.submitted ? this.rateOk : null;
    },
  },
  methods: {
    saveSalesTax() {
      this.submitted = true;
      if (this.nameOk && this.rateOk) {
        this.localSalesTax.rateInPercentage = parseFloat(this.localSalesTax.rateInPercentage) || 0;
        this.$emit("save", this.localSalesTax);
        return;
      }
      const ref = !this.nameOk ? this.$refs.nameInput : this.$refs.rateInput;
      this.$nextTick(() => {
        const el = ref && ref.$el.querySelector("input");
        if (el) el.focus();
      });
    },
  },
};
</script>